import { render, staticRenderFns } from "./tabsCom.vue?vue&type=template&id=4869a05b&scoped=true&"
import script from "./tabsCom.vue?vue&type=script&lang=js&"
export * from "./tabsCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4869a05b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4869a05b')) {
      api.createRecord('4869a05b', component.options)
    } else {
      api.reload('4869a05b', component.options)
    }
    module.hot.accept("./tabsCom.vue?vue&type=template&id=4869a05b&scoped=true&", function () {
      api.rerender('4869a05b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plantWorkbench/components/tabsCom.vue"
export default component.exports